/* eslint-disable max-statements */
/* eslint-disable xss/no-mixed-html */
/* eslint-disable vars-on-top */
$(document).ready(function() {
  var decisionpageItem = '.ph-decisionpage__cards',
      imageIconCheck = 'ph-icon-checkmark',
      imageViewId = '#viewimage',
      $imagetoggletick = $('#plp-imagetoggletick'),
      iconCheck = 'ph-icon-checkmark',
      $listviewonly = $('.ph-listview-only'),
      $gridviewonly = $('.ph-gridview-only'),
      decpagelist = 'ph-decisionpage__list',
      decgrid = 'ph-decisionpage__grid',
      hideimage = 'ph-hideimage',
      showimage = 'ph-showimage',
      $viewtoggletick = $('#plp-viewtoggletick'),
      $viewmode = $('#viewmode'),
      $viewimage = $('#viewimage'),
      $addToCartButton = $('.ph-cart');

  $('#plp-viewtoggle').click(function() {
    var decisionItem = '.ph-decisionpage__cards';

    $(decisionItem).removeClass('ph-decisionpage__list ph-decisionpage__grid');
    $viewtoggletick.removeClass(iconCheck);

    if ($viewmode.val() === 'grid') {
      $viewtoggletick.addClass(iconCheck);
      $viewmode.val('list');
      $(decisionItem).addClass(decpagelist);
      $listviewonly.removeClass('hidden');
      $gridviewonly.addClass('hidden');
      localStorage.setItem('viewmode', 'list');
    } else if ($viewmode.val() === 'list') {
      $viewmode.val('grid');
      $(decisionItem).addClass(decgrid);
      $listviewonly.addClass('hidden');
      $gridviewonly.removeClass('hidden');
      localStorage.setItem('viewmode', 'grid');
    }

    $('.ph-decisionpage-menutooltip').addClass('hidden');
  });
  $('#plp-imagetoggle').click(function() {
    $(decisionpageItem).removeClass('ph-hideimage ph-showimage');
    $imagetoggletick.removeClass(imageIconCheck);

    if ($(imageViewId).val() === 'FALSE') {
      $(imageViewId).val('TRUE');
      $(decisionpageItem).addClass(hideimage);
      localStorage.setItem('imageViewId', 'TRUE');
    } else if ($(imageViewId).val() === 'TRUE') {
      $imagetoggletick.addClass(imageIconCheck);
      $(imageViewId).val('FALSE');
      $(decisionpageItem).addClass(showimage);
      localStorage.setItem('imageViewId', 'FALSE');
    }

    $('.ph-decisionpage-menutooltip').addClass('hidden');
  });
  $('#ph-search-again').click(function() {
    if ($('.ph-headerparent__searchiconparentmobile').is(':visible')) {
      $('.ph-headerparent__hamburgermobile').click();
    }

    $('#search').focus();
  });
  $viewmode.val(localStorage.getItem('viewmode'));

  if ($viewmode.val() === '') {
    $viewmode.val('grid');
  }

  if ($viewmode.val() === 'list') {
    $viewtoggletick.addClass(iconCheck);
    $(decisionpageItem).addClass(decpagelist);
    $(decisionpageItem).removeClass(decgrid);
    $listviewonly.removeClass('hidden');
    $gridviewonly.addClass('hidden');
  } else if ($viewmode.val() === 'grid') {
    $viewtoggletick.removeClass(iconCheck);
    $listviewonly.addClass('hidden');
    $gridviewonly.removeClass('hidden');
  }

  ACC.decisionpage.removeCardDelayCls();
  $viewimage.val(localStorage.getItem('imageViewId'));

  if ($viewimage.val() === '') {
    $viewimage.val('FALSE');
  }

  if ($(imageViewId).val() === 'TRUE') {
    $(decisionpageItem).removeClass(showimage);
    $(decisionpageItem).addClass(hideimage);
    $imagetoggletick.removeClass(imageIconCheck);
  } else if ($(imageViewId).val() === 'FALSE') {
    $(decisionpageItem).removeClass(hideimage);
    $(decisionpageItem).addClass(showimage);
    $imagetoggletick.addClass(imageIconCheck);
  }

  /* New decision redesign code end */
  if ($('.ph-disablebutton').length > 0) {
    $addToCartButton.attr('disabled', 'disabled');
    $addToCartButton.addClass('ph-disable-button');
    $('.ph-addToCartButton').addClass('ph-disable-button');
    $('.ph-notify-sec').addClass('ph-disable-notifyme-btn');
  }
});

ACC.decisionpage = {
  backorderNotifyCheck: function(product) {
    var backorderFlag = $('.ph-nobackorderprod').val(),
        notifyFlag = $('#ph-notifyflag').val();

    if (backorderFlag === 'true' && notifyFlag === 'true') {
      product.find('.ph-cartcontent').addClass('hidden');
      product.find('.ph-notifyme').removeClass('hidden');
    }

    if (backorderFlag === 'true' && notifyFlag === 'false') {
      product.find('.ph-notifyblock').addClass('hidden');
      product.find('.ph-cartcontent').removeClass('hidden');
      product.find('.ph-addToCartButton').attr('disabled', 'disabled');
      product.find('.ph-cart').addClass('ph-outofstockdisablebtn');
    }
  },
  backorderNotifyEmailtrigger: function(prodcode, email, decQtyVal) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/asyncproduct/backInStockNotifyRequest ',
      type: 'POST',
      datatype: 'json',
      data: {
        product12Nc: prodcode,
        email: email,
        quantityRequested: decQtyVal
      },
      success: function() {
        $.colorbox({
          width: '400px',
          maxWidth: '90%',
          height: 'auto',
          html: $('.ph-notifyconfirmpop').html(),
          overlayClose: true
        });
      }
    });
  },
  loadProductPromotion: function(result, index) {
    var product = result[index];
    var priceList = result[index].priceList;
    // Var pricesTextStrike = '';
    var prodRow = '#ph-pl-row-';
    var $isPromotionEnabled = $('.ph-promotionenabled');

    if (priceList.length > 0) {
      for (var priceIndex = 0; priceIndex < priceList.length; priceIndex = priceIndex + 1) {
        var priceRow = priceList[priceIndex];

        // Promotion setup
        if (priceRow.pricingConditionCode === 'YDNC' && $isPromotionEnabled.length > 0) {
          $(prodRow + product.code).addClass('ph-filter-promo');
          $(prodRow + product.code).removeClass('ph-filter-notpromo');
          $(prodRow + product.code).css('visibility', 'visible');
        }
      }
    }
  },
  updatepromotionflyout: function($promotionValue) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/updateMarketingPreference',
      data: {
        marketingPreference: $promotionValue
      },
      type: 'POST',
      datatype: 'json',
      success: function() {
        setTimeout(function() {
          $('.ph-flyout_main').addClass('hidden');
        }, 1000);
      },
      error: function() {
        $('.ph-flyout_main').removeClass('hidden');
      }
    });
  },
  removeCardDelayCls: function() {
    var categoryCode = $('.ph-headerparent__categorycode').val();

    if (categoryCode !== 'PromotionalCategory') {
      $('#decisionpageCards').removeClass('ph-card-delay');
    }
  }

};

/* eslint-enable max-statements */
/* eslint-enable xss/no-mixed-html */
/* eslint-enable vars-on-top */
